import { useTranslation } from 'react-i18next';
import { useSlotContent } from './slots.tsx';

/**
 * A terceira coluna do layout "Três colunas" (ADR 0128): o item escolhido na lista, que a tela
 * põe no lugar `inspector`. Sem nada escolhido, a coluna não aparece e a tela usa a largura toda.
 */
export function InspectorPanel() {
  const { t } = useTranslation();
  const content = useSlotContent('inspector');
  if (!content) return null;
  return (
    <aside
      aria-label={t('nav.inspector')}
      className="hidden w-80 shrink-0 flex-col overflow-y-auto border-l border-rule bg-sheet lg:flex"
    >
      {content}
    </aside>
  );
}
